import {
  Button,
  CloseButton,
  Flex,
  Heading,
  Modal,
  Text,
  TextArea,
} from "@instructure/ui";
import { t } from "i18next";
import { useEffect, useState } from "react";

const RatingDescriptionModal = ({
  openModal,
  setOpenModal,
  descData,
  handleSaveDesc,
}) => {
  const [desc, setDesc] = useState("");

  useEffect(() => {
    setDesc(descData.description);
  }, [descData]);

  return (
    <Modal
      open={openModal}
      label={t("ratingScale.descriptionDialog")}
      size="medium"
      onDismiss={() => setOpenModal(false)}
    >
      <Modal.Header>
        <CloseButton
          placement="end"
          offset="small"
          onClick={() => setOpenModal(false)}
          screenReaderLabel={t("global.close")}
        />
        <Heading as="h3">{t("ratingScale.description")}</Heading>
      </Modal.Header>
      <Modal.Body>
        <Flex wrap="wrap" alignItems="start" gap="small">
          <Flex.Item shouldGrow>
            <Text>
              <strong>{t("ratingScale.lo")}: </strong>
              {descData.row.slo}
            </Text>
          </Flex.Item>
          <Flex.Item>
            <Text>
              <strong>{t("ratingScale.masteryLevel")}: </strong>
              {descData.masteryLevel}
            </Text>
          </Flex.Item>
          <Flex.Item>
            <Text>
              <strong>{t("ratingScale.score")}: </strong>
              {descData.column.score}
            </Text>
          </Flex.Item>
          <Flex.Item shouldGrow size="100%">
            <TextArea
              placeholder={t("ratingScale.descriptionPlaceholder")}
              label={t("ratingScale.description")}
              defaultValue={descData.description}
              onChange={(e) => setDesc(e.target.value)}
            />
          </Flex.Item>
        </Flex>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={() => setOpenModal(false)} margin="0 x-small 0 0">
          {t("global.cancel")}
        </Button>
        <Button onClick={() => handleSaveDesc(desc)} color="primary">
          {t("global.save")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RatingDescriptionModal;
